import { useCallback } from 'react';
import { refreshReview } from '@hydra/utils/reviewApi';
import { LanguagesTypes } from '@hydra/types';

interface RefreshReviewProps {
  url: string
  isFree?: boolean
  handleError: (error: Error) => void
  isProject?: boolean
  isUrlDifferent?: boolean
  locale?: LanguagesTypes
}

const useRefreshReview = ({ url, isFree, handleError, isProject, locale = 'en', isUrlDifferent = false }: RefreshReviewProps) => {
  return useCallback(async () => {
    try {
      const { generation } = await refreshReview({ url, isFree });
      if (isProject) {
        const redirectLocation = `/${locale}/project-review/${encodeURIComponent(url)}?${new URLSearchParams({ generationId: generation.id })}`;
        window.location.href = redirectLocation;
      } else {
        if (isUrlDifferent) {
          const currentUrl = new URL(window.location.href);
          const pathnameParts = currentUrl.pathname.split('/');
          pathnameParts[pathnameParts.length - 1] = encodeURIComponent(url);
          const href = `${currentUrl.origin}${pathnameParts.join('/')}${currentUrl.search}${currentUrl.hash}`;
          const newUrl = new URL(href);
          newUrl.searchParams.append('generationId', generation.id);
          newUrl.searchParams.set('href', url);
          window.location.href = newUrl.href;
          return;
        }

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.append('generationId', generation.id);
        window.location.href = currentUrl.href;
      }
    } catch (error) {
      handleError(error);
    }
  }, [url, isFree, handleError, isProject, locale, isUrlDifferent]);
};

export default useRefreshReview;
